import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import Spinner from '@atlaskit/spinner';
export var LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(LoadingSpinnerContainer, null, /*#__PURE__*/React.createElement(Spinner, {
    size: size
  }), /*#__PURE__*/React.createElement(LoadingSpinnerMessage, null, children));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var LoadingSpinnerContainer = styled.div({
  textAlign: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
var LoadingSpinnerMessage = styled.p({});